import { z } from "zod";
import { normalizeImageUrl } from "../shared/date-validation";

export const ProductImageItemSchema = z.object({
  IsVideo: z.boolean().optional(),
  ThumbnailUrl: z.string().transform((value) => normalizeImageUrl(value)),
  Url: z.string().transform((value) => normalizeImageUrl(value)),
});

export type ProductImageItemType = z.infer<typeof ProductImageItemSchema>;
